/**
 * A prévia do álbum no painel: o `gallery_preview.dart`.
 *
 * Seis fotos numa fileira que rola, rosa-quartzo, e a seção inteira levando a
 * `/galeria` — é a fatia de `dashboard_screen.dart:483`, entre a agenda e a
 * estante.
 *
 * As palavras da legenda são as de lá, em inglês: `'no photos yet'` e
 * `'N photos'`. Estão no Flutter assim e o porte não traduz o que o outro app
 * mostra — dois textos diferentes para a mesma coisa seria a casa falando duas
 * línguas dependendo do aparelho.
 *
 * O que o navegador obrigou a mudar: lá cada foto tem o seu `onTap`, e lá ele
 * vai para `/gallery` — o mesmo destino do toque da seção. Aqui a seção é um
 * `<a>`, e um `<button>` dentro de um `<a>` é HTML inválido; como o destino é
 * o mesmo, as fichas saem sem clique e quem leva é o link de fora.
 */

import { useMemo } from 'react';
import { COLECOES, fotoDeMapa, fotosRecentes, traduzir, usarColecao } from '@nosso-sempre/shared';
import { FichaDaEstante } from './FichaDaEstante';
import { Icone } from './Icone';
import { Secao, SetaDaSecao } from './Secao';
import './previas.css';

/** O `limit: 6` do `getRecentPhotos` de lá. */
const QUANTAS = 6;

export function PreviaDaGaleria() {
  const documentos = usarColecao<Record<string, unknown>>(COLECOES.galeria);

  const fotos = useMemo(() => {
    const todas = documentos.map((d) => fotoDeMapa(d.id, d.dados));
    return fotosRecentes(todas, QUANTAS);
  }, [documentos]);

  const quantas = documentos.length;
  const legenda =
    quantas === 0 ? 'no photos yet' : `${quantas} ${quantas === 1 ? 'photo' : 'photos'}`;

  return (
    <Secao
      icone="fotos"
      cor="var(--rosa-quartzo)"
      titulo={traduzir('Galeria de memórias')}
      legenda={legenda}
      para="/galeria"
      ponta={<SetaDaSecao />}
    >
      {fotos.length === 0 ? (
        <p className="previa-convite">
          <Icone nome="mais-circulo" tamanho={18} />
          {traduzir('Coloque a primeira memória no álbum')}
        </p>
      ) : (
        <ul className="previa-estante">
          {fotos.map((f) => (
            <li key={f.id}>
              <FichaDaEstante capa={f.endereco} icone="fotos" titulo="" />
            </li>
          ))}
        </ul>
      )}
    </Secao>
  );
}
